import * as browser from '../tests';

const scroller =
	browser.edge || browser.ie || browser.firefox
		? document.documentElement
		: document.body;

let scroll = 0;
let locked = false;

/**
 * @function isLocked
 * @description Returns state
 */

export const isLocked = () => locked;

/**
 * @function lock
 * @description Lock the body at a particular position and prevent scroll,
 * use margin to simulate original scroll position.
 */

export const lock = () => {
	locked = true;
	scroll = scroller.scrollTop;
	document.body.style.position = 'fixed';
	document.body.style.marginTop = `-${scroll}px`;
};

/**
 * @function unlock
 * @description Unlock the body and return it to its actual scroll position.
 */

export const unlock = () => {
	locked = false;
	document.body.style.marginTop = '0px';
	document.body.style.position = 'relative';
	scroller.scrollTop = scroll;
};
